module.exports = __webpack_public_path__ + "static/img/eyePosition.d0385df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eyePosition.png
// module id = 5aXv
// module chunks = 3